// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_Impl_AppM from "../Fusion.Impl.AppM/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Fusion_Impl_AppM.bindAppM);
var empty = /* #__PURE__ */ WE_Class_AVar.empty(Fusion_Impl_AppM.manageAVarAVarAppM);
var $$new = /* #__PURE__ */ WE_Class_MonadRef["new"](Fusion_Impl_AppM.monadRefRefAppM);
var put = /* #__PURE__ */ WE_Class_AVar.put(Fusion_Impl_AppM.manageAVarAVarAppM);
var now = /* #__PURE__ */ WE_Class_Time.now(Fusion_Impl_AppM.monadTimeAppM);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Fusion_Impl_AppM.bindAppM);
var $$void = /* #__PURE__ */ Data_Functor["void"](Fusion_Impl_AppM.functorAppM);
var fork = /* #__PURE__ */ Control_Monad_Fork_Class.fork(Fusion_Impl_AppM.monadForkAppFiberAppMFSEr);
var delay = /* #__PURE__ */ WE_Class_Time.delay(Fusion_Impl_AppM.monadTimeAppM);
var read = /* #__PURE__ */ WE_Class_MonadRef.read(Fusion_Impl_AppM.monadRefRefAppM);
var sequence_ = /* #__PURE__ */ Data_Foldable.sequence_(Fusion_Impl_AppM.applicativeAppM)(Data_Foldable.foldableMaybe);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Fusion_Impl_AppM.monadEffectAppM);
var kill_ = /* #__PURE__ */ Fusion_Generator.kill_(Fusion_Impl_AppM.monadKillFSErrorAppFiberA);
var take = /* #__PURE__ */ WE_Class_AVar.take(Fusion_Impl_AppM.manageAVarAVarAppM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Fusion_Impl_AppM.applicativeAppM);
var fetchDownloadStreamer = function (url) {
    return bind(empty)(function (avEvents) {
        return bind($$new(Data_Maybe.Nothing.value))(function (abortRef) {
            var emitEvent = function (event) {
                return put(event)(avEvents);
            };
            return bind(now)(function (timestampStart) {
                return discard($$void(fork(emitEvent({
                    timestamp: timestampStart,
                    payload: MST_Data_StreamEvent.Start.value
                }))))(function () {
                    return bind(fork(discard(delay(Fusion_Data_Duration.fromMs(3000.0)))(function () {
                        return bind(read(abortRef))(function (abort) {
                            return discard(sequence_(abort))(function () {
                                return bind(now)(function (timestamp) {
                                    return emitEvent({
                                        timestamp: timestamp,
                                        payload: new MST_Data_StreamEvent.Fail({
                                            message: "Fetch Timeout"
                                        })
                                    });
                                });
                            });
                        });
                    })))(function (timeoutFiber) {
                        return bind(liftEffect(function () {
                            return $foreign.fetchImpl({
                                url: MST_Data_BasicURL.print(url),
                                onChunk: function (v) {
                                    return Fusion_Impl_AppM.launchAppM_(emitEvent({
                                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(v.timestamp)),
                                        payload: new MST_Data_StreamEvent.LoadedBytes({
                                            bytes: Fusion_Data_Bytes.fromInt(v.bytes)
                                        })
                                    }))();
                                },
                                onFetchFail: function (msg) {
                                    return Fusion_Impl_AppM.launchAppM_(bind(now)(function (timestamp) {
                                        return emitEvent({
                                            timestamp: timestamp,
                                            payload: new MST_Data_StreamEvent.Fail({
                                                message: msg
                                            })
                                        });
                                    }))();
                                },
                                onResponseStart: function (v) {
                                    return Fusion_Impl_AppM.launchAppM_(discard(kill_(timeoutFiber))(function () {
                                        return emitEvent({
                                            timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(v.timestamp)),
                                            payload: MST_Data_StreamEvent.ResponseStart.value
                                        });
                                    }))();
                                },
                                onFetchSucceed: function (v) {
                                    return Fusion_Impl_AppM.launchAppM_(emitEvent({
                                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(v.timestamp)),
                                        payload: MST_Data_StreamEvent.ResponseEnd.value
                                    }))();
                                }
                            });
                        }))(function (v) {
                            var next = take(avEvents);
                            var cancel = liftEffect(function () {
                                return v.abort(Data_Unit.unit);
                            });
                            return pure({
                                next: next,
                                cancel: cancel
                            });
                        });
                    });
                });
            });
        });
    });
};
export {
    fetchDownloadStreamer
};
